import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export function SitemarkIcon() {
  return (
    <SvgIcon sx={{ height: 21, width: 100, mr: 2 }}>
      <svg
        width={86}
        height={19}
        viewBox="0 0 86 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#B4C0D3"
          d="m.787 12.567 6.055-2.675 3.485 2.006.704 6.583-4.295-.035.634-4.577-.74-.422-3.625 2.817-2.218-3.697Z"
        />
        <path
          fill="#00D3AB"
          d="m10.714 11.616 5.352 3.908 2.112-3.767-4.295-1.725v-.845l4.295-1.76-2.112-3.732-5.352 3.908v4.013Z"
        />
        <path
          fill="#4876EF"
          d="m10.327 7.286.704-6.583-4.295.07.634 4.577-.74.422-3.66-2.816L.786 6.617l6.055 2.676 3.485-2.007Z"
        />
        <path
          fill="#4876EE"
          d="M32.507 8.804v6.167h2.312v-7.86h-3.366v1.693h1.054ZM32.435 6.006c.212.22.535.33.968.33.434 0 .751-.11.953-.33.213-.23.318-.516.318-.86 0-.354-.105-.641-.318-.86-.202-.23-.52-.345-.953-.345-.433 0-.756.115-.968.344-.202.22-.303.507-.303.86 0 .345.101.632.303.861ZM24.46 14.799c.655.296 1.46.444 2.413.444.896 0 1.667-.139 2.312-.416.645-.277 1.141-.664 1.488-1.162.357-.506.535-1.094.535-1.764 0-.65-.169-1.2-.506-1.649-.328-.459-.785-.818-1.373-1.076-.587-.267-1.266-.435-2.037-.502l-.809-.071c-.481-.039-.828-.168-1.04-.388a1.08 1.08 0 0 1-.318-.774c0-.23.058-.44.173-.631.116-.201.29-.359.52-.474.241-.114.535-.172.882-.172.366 0 .67.067.91.201.053.029.104.059.15.09l.012.009.052.037c.146.111.263.243.35.395.125.21.188.444.188.703h2.311c0-.689-.159-1.286-.476-1.793-.318-.516-.776-.913-1.373-1.19-.588-.287-1.296-.43-2.124-.43-.79 0-1.474.133-2.052.4a3.131 3.131 0 0 0-1.358 1.12c-.318.487-.477 1.066-.477 1.735 0 .927.314 1.673.94 2.237.626.564 1.464.89 2.514.976l.794.071c.645.058 1.113.187 1.401.388a.899.899 0 0 1 .434.788 1.181 1.181 0 0 1-.231.717c-.154.201-.38.36-.68.474-.298.115-.669.172-1.112.172-.49 0-.89-.067-1.199-.2-.308-.144-.539-.33-.694-.56a1.375 1.375 0 0 1-.216-.746h-2.297c0 .679.168 1.281.505 1.807.337.517.834.928 1.489 1.234ZM39.977 15.07c-.8 0-1.445-.095-1.936-.286a2.03 2.03 0 0 1-1.084-.99c-.221-.469-.332-1.1-.332-1.893V8.789h-1.2V7.11h1.2V4.988h2.153V7.11h2.312V8.79h-2.312v3.198c0 .373.096.66.289.86.202.192.486.287.852.287h1.17v1.937h-1.112Z"
        />
        <path
          fill="#4876EE"
          fillRule="evenodd"
          d="M43.873 14.899c.52.23 1.117.344 1.791.344.665 0 1.252-.115 1.763-.344.51-.23.934-.55 1.271-.96.337-.412.564-.88.679-1.407h-2.124c-.096.24-.279.44-.549.603-.27.162-.616.244-1.04.244-.262 0-.497-.031-.704-.093a1.572 1.572 0 0 1-.423-.194 1.662 1.662 0 0 1-.636-.803 3.159 3.159 0 0 1-.163-.645h5.784v-.775a4.28 4.28 0 0 0-.463-1.98 3.686 3.686 0 0 0-1.343-1.477c-.578-.382-1.291-.574-2.139-.574-.645 0-1.223.115-1.733.345-.501.22-.92.52-1.257.903a4.178 4.178 0 0 0-.78 1.305c-.174.478-.26.98-.26 1.506v.287c0 .507.086 1.004.26 1.492.183.478.443.913.78 1.305.347.382.775.688 1.286.918Zm-.094-4.674.02-.09a2.507 2.507 0 0 1 .117-.356c.145-.354.356-.622.636-.804.104-.067.217-.123.339-.165.204-.071.433-.107.686-.107.395 0 .723.09.983.272.27.173.472.426.607.76a2.487 2.487 0 0 1 .16.603h-3.57c.006-.038.013-.076.022-.113Z"
          clipRule="evenodd"
        />
        <path
          fill="#4876EE"
          d="M50.476 14.97V7.112h1.835v1.98a4.54 4.54 0 0 1 .173-.603c.202-.536.506-.937.91-1.205.405-.277.9-.416 1.488-.416h.101c.598 0 1.094.139 1.489.416.404.268.707.67.91 1.205l.016.04.013.037.028-.077c.212-.536.52-.937.925-1.205.405-.277.901-.416 1.489-.416h.1c.598 0 1.098.139 1.503.416.414.268.727.67.94 1.205.211.535.317 1.205.317 2.008v4.475h-2.312v-4.604c0-.43-.115-.78-.346-1.047-.222-.268-.54-.402-.954-.402-.414 0-.742.139-.982.416-.241.268-.362.626-.362 1.076v4.56h-2.326v-4.603c0-.43-.115-.78-.346-1.047-.222-.268-.535-.402-.94-.402-.423 0-.756.139-.996.416-.241.268-.362.626-.362 1.076v4.56h-2.311Z"
        />
        <path
          fill="#4876EE"
          fillRule="evenodd"
          d="M68.888 13.456v1.515h1.834v-4.82c0-.726-.144-1.319-.433-1.778-.289-.468-.712-.817-1.271-1.047-.549-.23-1.228-.344-2.037-.344a27.76 27.76 0 0 0-.896.014c-.318.01-.626.024-.924.043l-.229.016a36.79 36.79 0 0 0-.552.042v1.936a81.998 81.998 0 0 1 1.733-.09 37.806 37.806 0 0 1 1.171-.025c.424 0 .732.1.925.301.193.201.289.502.289.904v.029h-1.43c-.704 0-1.325.09-1.864.272-.54.172-.959.445-1.257.818-.299.363-.448.832-.448 1.405 0 .526.12.98.361 1.363.24.373.573.66.997.86.433.201.934.302 1.502.302.55 0 1.012-.1 1.388-.302.385-.2.683-.487.895-.86a2.443 2.443 0 0 0 .228-.498l.018-.056Zm-.39-1.397v-.63h-1.445c-.405 0-.718.1-.939.3-.212.192-.318.455-.318.79 0 .157.026.3.08.429a.99.99 0 0 0 .238.345c.221.191.534.287.939.287a2.125 2.125 0 0 0 .394-.038c.106-.021.206-.052.3-.092.212-.095.385-.253.52-.473.135-.22.212-.526.23-.918Z"
          clipRule="evenodd"
        />
        <path
          fill="#4876EE"
          d="M72.106 14.97V7.11h1.835v2.595c.088-.74.31-1.338.665-1.791.481-.603 1.174-.904 2.08-.904h.303v1.98h-.578c-.635 0-1.127.172-1.473.516-.347.334-.52.822-.52 1.463v4.001h-2.312ZM79.92 11.298h.767l2.499 3.672h2.6l-3.169-4.51 2.606-3.35h-2.427l-2.875 3.737V4.5h-2.312v10.47h2.312v-3.672Z"
        />
      </svg>
    </SvgIcon>
  );
}

export function FacebookIcon() {
  return (
    <SvgIcon>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.68 15.92C2.88 15.24 0 11.96 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 11.96 13.12 15.24 9.32 15.92L8.88 15.56H7.12L6.68 15.92Z"
          fill="url(#paint0_linear_795_116)"
        />
        <path
          d="M11.12 10.2391L11.48 7.99914H9.36V6.43914C9.36 5.79914 9.6 5.31914 10.56 5.31914H11.6V3.27914C11.04 3.19914 10.4 3.11914 9.84 3.11914C8 3.11914 6.72 4.23914 6.72 6.23914V7.99914H4.72V10.2391H6.72V15.8791C7.16 15.9591 7.6 15.9991 8.04 15.9991C8.48 15.9991 8.92 15.9591 9.36 15.8791V10.2391H11.12Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_795_116"
            x1="8"
            y1="0"
            x2="8"
            y2="15.9991"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1AAFFF" />
            <stop offset="1" stopColor="#0163E0" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function JobTrackerIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 505 505">
      <circle style={{ fill: "#84DBFF" }} cx="252.5" cy="252.5" r="252.5" />
      <rect
        x="304.068"
        y="295.985"
        transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 772.4481 319.9108)"
        style={{ fill: "#2B3B4E" }}
        width="31.8"
        height="47.9"
      />

      <path
        style={{ fill: "#F9B54C" }}
        d="M234.7,234.5c0-0.6,0.1-1.2,0-1.8c-0.1-2.6,1.1-4.8,3.1-6.2c-6.1-9.4-11.2-23.8-11.2-23.8h-19.5
	c0,0-7.7,22.3-15.4,29.4l24.7,7.9v0.4l0.6-0.2l0.6,0.2V240L234.7,234.5z"
      />
      <path
        style={{ fill: "#E6E9EE" }}
        d="M241.2,230.9l-24.4,2.1l-22.6-2.2L193,231c0,0-10.5,21.8-11.4,23.8c-0.8,2.1,8.3,41.1,8.3,43.8
	c0,2.7,35.1,18,35.1,18l22.7-37.4L241.2,230.9z"
      />
      <polygon
        style={{ fill: "#F1543F" }}
        points="220.8,246.4 212.8,246.4 207.5,233 226.1,233 "
      />
      <polygon
        style={{ fill: "#FF7058" }}
        points="220.8,246.4 212.8,246.4 207.5,280.8 216.8,293.1 226.1,280.8 "
      />
      <g>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M235,221.7c0,0,13.7,11.7-6.7,24.5l-11.5-13L235,221.7z"
        />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M198.6,221.7c0,0-13.7,11.7,6.7,24.5l11.5-13L198.6,221.7z"
        />
      </g>
      <g>
        <path
          style={{ fill: "#4CDBC4" }}
          d="M171.1,286.2c0,0-1.2,3.8-2.7,10.3c-0.7,2.7-1.4,5.9-2.1,9.4c-10.2-5.8-19.3-13.4-26.9-22.3
		c2.7-13.8,6.7-27.7,12.7-40.9c0,0,0,0,0.1,0.1l4.6,10.6c0,0.1,0.1,0.2,0.1,0.3L171.1,286.2z"
        />
        <path
          style={{ fill: "#4CDBC4" }}
          d="M223.7,319.2c-2.2,0.1-4.4,0.2-6.6,0.2c-2.2,0-4.4-0.1-6.6-0.2c-14.5-0.9-28.1-4.9-40.3-11.2
		c-0.5-4-1.1-7.8-1.7-11.5c-3.3-19.1-8-33.7-11.6-42.8c0-0.1-0.1-0.2-0.1-0.3c-2.4-6.3-4.3-10-4.6-10.6c0-0.1-0.1-0.1-0.1-0.1
		c12-0.8,21.6-4.1,28.9-7.7h0.1c9.4-4.7,14.6-9.8,15.2-10.5l0,0l0,0l-1.6,3.2l-1.4,2.7L193,231l0,0v0.1l-0.2,1.5l-2.5,17l14.5,43.7
		l11.6,15.7l0,0l0.7,1l1.5,2l2.1,2.7l0,0l2.1,2.8l0,0l0,0C223.1,317.9,223.4,318.5,223.7,319.2z"
        />
      </g>
      <path
        style={{ fill: "#2C9984" }}
        d="M196.3,224.4c0,0-6,39.3,26.5,93.1c0,0-25.4-12.8-42.3-76.2l9.8-4.1l-9.8-1.9L196.3,224.4z"
      />
      <path
        style={{ fill: "#4CDBC4" }}
        d="M294.8,283.6c-7.6,8.9-16.7,16.4-27,22.3c-0.7-3.5-1.4-6.7-2.1-9.4c-1.5-6.4-2.7-10.3-2.7-10.3
	l14.4-32.8c0,0,0-0.1,0.1-0.1l4.6-10.5c0-0.1,0.1-0.1,0.1-0.1C288.1,256,292.1,269.8,294.8,283.6z"
      />
      <path
        style={{ fill: "#2C9984" }}
        d="M282.1,242.7c0,0,0,0-0.1,0.1c-0.4,0.7-2.2,4.3-4.6,10.5l-0.1,0.1c-3.5,9.1-8.3,23.8-11.7,43.1
	c-0.6,3.6-1.2,7.5-1.7,11.5c-12.2,6.3-25.9,10.3-40.3,11.2c-2.2,0.1-4.4,0.2-6.6,0.2c-2.2,0-4.4-0.1-6.6-0.2c0.3-0.7,0.6-1.2,1-1.7
	l0,0l3.9-5.2l0.3-0.4l0,0l1.5-2l0.7-1l0,0l11.6-15.7l14.3-43.3l0,0l0.1-0.4l-2.7-18.6l-3.2-6.5l0,0c0.6,0.7,5.8,5.8,15.2,10.5
	C260.4,238.5,270.1,241.9,282.1,242.7z"
      />
      <path
        style={{ fill: "#4CDBC4" }}
        d="M237.9,224.4c0,0,6,39.3-26.5,93.1c0,0,25.4-12.8,42.3-76.2l-9.8-4.1l9.8-1.9L237.9,224.4z"
      />
      <g>
        <path
          style={{ fill: "#F9B54C" }}
          d="M247.3,181.6c-0.4,4.7-2.1,8.6-3.8,8.6s-2.8-3.8-2.4-8.6c0.4-4.7,2.1-8.6,3.8-8.6
		S247.7,176.9,247.3,181.6z"
        />
        <path
          style={{ fill: "#F9B54C" }}
          d="M186.9,181.6c0.4,4.7,2.1,8.6,3.8,8.6s2.8-3.8,2.4-8.6c-0.4-4.7-2.1-8.6-3.8-8.6
		S186.5,176.9,186.9,181.6z"
        />
      </g>
      <path
        style={{ fill: "#FFD05B" }}
        d="M238.2,154.7c-1.6-3.4-5.2-5.7-9.1-5.7h-11.8h-11.8c-4,0-7.5,2.2-9.1,5.7c-3.8,8.4-4.6,22.8-4.6,32.7
	c0,6.5,2.5,12.8,7.1,17.7l3.7,3.9c3.4,3.6,7.8,6.3,12.7,7.7l2.1,0.6l2.1-0.6c4.9-1.4,9.3-4,12.7-7.7l3.7-3.9
	c4.6-4.9,7.1-11.2,7.1-17.7C242.8,177.6,242,163.1,238.2,154.7z"
      />
      <path
        style={{ fill: "#11110F" }}
        d="M245.8,146.5c-0.4-1.4-1-2.7-1.4-4.1c-0.3-0.9-0.5-1.9-0.9-2.8c-1-1.8-3.2-2.8-5.3-2.6
	s-3.9,1.4-5.4,2.9c0.3-2,0.4-4.1-0.6-5.8c-1.1-2-3.3-3.1-5.5-3.5s-4.5-0.3-6.7-0.5c-2.5-0.2-4.9-0.9-7.4-0.6c-2,0.2-3.9,1.3-5.9,1.8
	c-21,4.8-19.3,29.7-19,36.4c0.1,1.8,0.2,3.6,0.8,5.2c0.7,2.2,2.1,4,3.6,5.8c0.4-1.2,0.3-2.5,0.6-3.8c0.4-1.8,0.6-3.7,1.1-5.5
	c0.5-1.7,2.5-11,3.3-12.8c1.1-2.5,3.2-4.8,5.8-5.4c5-1.3,10.1,3.2,15.2,2.4c1-0.2,1.9-0.5,2.8-0.8c1.1-0.4,2.1-0.7,3.2-1
	c2.4-0.7,5-1.2,7.4-0.5c2.7,0.8,4.8,2.9,6.1,5.3c1.3,2.5,2,5.2,2.6,8c0.3,1.6,0.7,3.3,0.5,5c0,0.1,0,0.2,0,0.4c0.1,1.3,0,2.7,0.2,4
	c0.2,1,0.5,2,0.7,3.1c0.1,0.5,0.2,0.9,0.3,1.4c1.8-3.3,3-6.8,3.7-10.5c0.5-3,0.7-6,0.8-9.1C246.8,154.6,247,150.4,245.8,146.5z"
      />
    </SvgIcon>
  );
}

export function GoogleIcon() {
  return (
    <SvgIcon>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.68 8.18182C15.68 7.61455 15.6291 7.06909 15.5345 6.54545H8V9.64364H12.3055C12.1164 10.64 11.5491 11.4836 10.6982 12.0509V14.0655H13.2945C14.8073 12.6691 15.68 10.6182 15.68 8.18182Z"
          fill="#4285F4"
        />
        <path
          d="M8 16C10.16 16 11.9709 15.2873 13.2945 14.0655L10.6982 12.0509C9.98545 12.5309 9.07636 12.8218 8 12.8218C5.92 12.8218 4.15273 11.4182 3.52 9.52727H0.858182V11.5927C2.17455 14.2036 4.87273 16 8 16Z"
          fill="#34A853"
        />
        <path
          d="M3.52 9.52C3.36 9.04 3.26545 8.53091 3.26545 8C3.26545 7.46909 3.36 6.96 3.52 6.48V4.41455H0.858182C0.312727 5.49091 0 6.70545 0 8C0 9.29455 0.312727 10.5091 0.858182 11.5855L2.93091 9.97091L3.52 9.52Z"
          fill="#FBBC05"
        />
        <path
          d="M8 3.18545C9.17818 3.18545 10.2255 3.59273 11.0618 4.37818L13.3527 2.08727C11.9636 0.792727 10.16 0 8 0C4.87273 0 2.17455 1.79636 0.858182 4.41455L3.52 6.48C4.15273 4.58909 5.92 3.18545 8 3.18545Z"
          fill="#EA4335"
        />
      </svg>
    </SvgIcon>
  );
}
